const panelSelector = '[panel]';

if (document.querySelector(panelSelector)) {
  const togglePanel = event => {
    const container = event.target.closest(panelSelector);
    const isOpen = container?.getAttribute('data-open') === 'true';
    container?.setAttribute('data-open', String(!isOpen));
  };

  document.querySelectorAll(panelSelector).forEach(accordion => {
    const trigger = accordion.querySelector('button');
    trigger?.addEventListener('click', togglePanel);
  });
}